const VALIDATORS = {
    PHONE: 'PHONE',
    CAPTCHA: 'CAPTCHA',
    CODE: 'CODE',
};

export default VALIDATORS;